import { render, staticRenderFns } from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=template&id=9925487e&scoped=true"
import script from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=script&lang=js"
export * from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=style&index=0&id=9925487e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9925487e",
  null
  
)

export default component.exports